import { render } from "./ExpertStatisticsFullQueueReport.vue?vue&type=template&id=43c2229d"
import script from "./ExpertStatisticsFullQueueReport.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsFullQueueReport.vue?vue&type=script&lang=js"

import "./ExpertStatisticsFullQueueReport.vue?vue&type=style&index=0&id=43c2229d&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__